import { render } from "./ShowsCreateEdit.vue?vue&type=template&id=530956fa"
import script from "./ShowsCreateEdit.vue?vue&type=script&lang=js"
export * from "./ShowsCreateEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__